/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios";
import useApi, { ActionResult, Api, Model, Query, Response } from "../common/hooks/useApi"



const module = "Notificacion";

export default () => {
    const api = useApi({ module });

    return {

        EnviarEmailDesdeArchivo: async (archivo: FormData): Promise<{value:boolean, data: any}> => {
            try {
                var response = await api.axiosInstance.post(`${module}/email/archivo`, archivo);

                return { value: true, data: response.data };

            } catch (error: any | AxiosError) {
                return { value: false, data: error.response?.data?.message || "Error al conectar con el servidor" };
            }
        },
        MarcarEnviadasPostal: async (archivo: FormData): Promise<{value:boolean, data: any}> => {
            try {
                var response = await api.axiosInstance.post(`${module}/postal/archivo`, archivo);

                return { value: true, data: response.data };

            } catch (error: any | AxiosError) {
                return { value: false, data: error.response?.data?.message || "Error al conectar con el servidor" };
            }
        },
    }
}